import { render, staticRenderFns } from "./floatCurrency.vue?vue&type=template&id=60662338&scoped=true&"
import script from "./floatCurrency.vue?vue&type=script&lang=js&"
export * from "./floatCurrency.vue?vue&type=script&lang=js&"
import style0 from "./floatCurrency.vue?vue&type=style&index=0&id=60662338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60662338",
  null
  
)

export default component.exports